//const HOST_PORT= 'http://localhost:4000'
const HOST_PORT= '/backend'
export const URI_BIO = `${HOST_PORT}/biometrico`
export const URI_CAR = `${HOST_PORT}/cargos`  
export const URI_HCD = `${HOST_PORT}/hcd`
